module.exports = __webpack_public_path__ + "img/20191116143703144.7ff1bc85.jpg";